/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react"
import { CSSBorder } from "src/libs/interfaces/layouts"
import { ICurrentEditType } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import Canvas from "../../useful/Canvas"
import { ICanvasEditPanelProps } from "./CanvasEditForm"

/* Protopia Ecosystem component */
export interface ICanvasEditCanvasProps extends ICanvasEditPanelProps {
   
}

const CanvasEditCanvas = (props: ICanvasEditCanvasProps): JSX.Element => {
    const curEditModal: ICurrentEditType    = useLandingStore( (state: ILandingStore) => state.curEditModal ) 
    const { sectionId, value, isDifferent, onChange, onUpdate, } = props
    const [bounds, setBounds] = useState<DOMRect>( { width:0, height:0, } as DOMRect )
    const ref = useRef(null)
    
    const createCanvas = () => {
        const origin = document.querySelector(`.landing-canvas-${curEditModal.id}`)
        const bounds = origin?.getBoundingClientRect() || {} as DOMRect 
        setBounds( bounds )        
    }
    
    useEffect(() => {
        createCanvas()
    }, [])

    const border: CSSBorder = value.smart_background?.border || {}
    return <div 
        className='pe-canvas-edit-canvas-container position-fixed'
        style={{ 
            top: bounds.top,
            left: bounds.left,
            width: bounds.width,
            height: bounds.height,
            backgroundColor: value.smart_background?.color || "#FFFFFF77",
            outline: "1px dotted #000000",
            outlineOffset: 3,
            border: `${border.borderWidth || 0}px ${border.borderStyle || "solid"} ${border.borderColor || "transparent" }`
        }} 
        ref={ref}
    > 
        <Canvas data={value} />
    </div>
}
export default CanvasEditCanvas